<template>
    <div>
        <Clist :pBtnNewDisabled="BtnNewDisabled" :regresar="false" :EmitSeccion="ConfigModalPropuesta.EmitSeccion" :PNameButonNuevo="'Carga Manual'" :ShowFilas="false" :Nombre="NameList" :pShowBtnAdd="true" @FiltrarC="Lista" :Filtro="Filtro" :isModal="EsModal" :pConfigLoad="ConfigLoad">
			<template slot="Filtros">
				<div v-show="this.RolUsuario=='admin'" class="form-group mr-2">
					<label>Vendedor </label>
                    <select @change="Lista()"  v-model="Filtro.IdVendedor" class="form-control ml-2">
						<option value="">- Vendedor -</option>
                        <option v-for="(item,index) in ListaVendedores" :key="index" :value="item.IdVendedor">{{item.Nombre}}</option>
                    </select>
				</div>
				<div class="form-group mr-2">
					<label>Estatus </label>
                    <select @change="Lista()"  v-model="Filtro.Estatus" class="form-control ml-2">
						<option value="">- Estatus -</option>
						<option value="Activa">Activa</option>
						<option value="Ganada">Ganada</option>
						<option value="Perdida">Perdida</option>
						<option value="Reemplazada">Reemplazada</option>
						<!-- <option value="Vencida">Vencida</option> -->
                    </select>
				</div>
				<div class="form-group mr-2">
					<label>Tipo de Servicio </label>
                    <select @change="Lista()"  v-model="Filtro.Tipo" class="form-control ml-2">
						<option value="">- Tipo -</option>
						<option value="1">Mantenimiento</option>
						<option value="2">Servicio</option>
						<option value="3">Proyecto</option>
						<!-- <option value="Vencida">Vencida</option> -->
                    </select>
				</div>
			</template>
			<template slot="header">
                <tr>
                	<th>Propiedad</th>
                	<th>Número</th>
                	<th>Nombre Propuesta</th>
					<th>Tipo</th>
                	<th>Valor</th>
                	<th>Fecha</th>
                	<th>Vigencia</th>
                	<th class="text-center">Documentación</th>
                	<th>Estatus</th>
                	<th>Acciones</th>
                </tr>
            </template>
			<template slot="body">
				<tr v-for="(item,index) in ListPropuesta" :key="index" :class="item.Estatus=='Vencida' ? 'bg-danger':''">
					<td>{{ item.Propiedad }}</td>
                	<td>{{ item.Numero }}</td>
                	<td v-b-tooltip.hover.top :title="item.NombrePropuesta">{{ $limitCharacters(item.NombrePropuesta,28) }}</td>
					<td>{{ NombreTipoPropuesta(item.Tipo) }}</td>
                	<td>$ {{ $numberTo(parseFloat(item.Valor)) }}</td>
                	<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                	<td>{{ isNaN(item.Vigencia) ? item.Vigencia : item.Vigencia+' días' }}</td>
                	<td class="text-center">
						<button v-if="item.IdCotizacionServicio=='' || (item.ArchivoBruto!='' && item.ArchivoBruto!='Elegir Archivo(5MB)' && item.ArchivoBruto!='Elegir Archivo (0.5MB)')" @click="AbrirDocumento(item.Archivo)" class="btn-icon" title="Ver Documentación"><i class="fa fa-file-pdf"></i>
						</button>
						<button v-else-if="item.IdCotizacionServicio!='' && item.IdCotizacionServicio!=null && item.IdCotizacionServicio!='null' && item.IdCotizacionServicio!=0" @click="DescargarCliente(item.IdCotizacionServicio,item.FechaReg)" class="btn-icon" title="Ver Documentación"><i :id="'propuesta'+item.IdCotizacionServicio" class="fa fa-file-pdf"></i>
						</button>
						<span v-else>No Contiene Archivo</span>
					</td>
                	<td>{{ item.Estatus }}</td>
                	<td>
                	    <Cbtnaccion 
                	    :isModal="true" 
                	    :pEmitSeccion="ConfigModalPropuesta.EmitSeccion" 
                	    :Id="item.IdPropuesta"
                	    :IrA="ConfigModalPropuesta.Nombre"></Cbtnaccion>
                	</td>
                </tr>
				<CSinRegistros :pContIF="ListPropuesta.length" :pColspan="12" ></CSinRegistros>
            </template>
        </Clist>
		<Modal :Showbutton="ShowButtonPropuesta" :pEmitSeccion="ConfigModalPropuesta.EmitSeccion" :NameModal="ConfigModalPropuesta.NombreSeccion"  :size="ConfigModalPropuesta.Size" :Nombre="'Propuesta'" :poBtnSave="oBtnSavePropuesta">
            <template slot="Form">
                <FormPropuesta :pVendedor="Vendedor" :pOrigen="'modulo'" :NameList="ConfigModalPropuesta.NameForm" :poBtnSave="oBtnSavePropuesta">
                </FormPropuesta>
            </template>
        </Modal>
    </div>
</template>
<script>

import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import Modal from '@/components/Cmodal.vue';
import CSinRegistros from "../../../components/CSinRegistros";
import FormPropuesta from "../propuestas/Form.vue";

export default {
    name :'listCotizaciones',
    components :{
        Clist,
		Cbtnaccion,
		CSinRegistros,
		FormPropuesta,
		Modal
    },
    data() {
        return {
            FormName:'cotizacion_principal',//Por si no es modal y queremos ir a una vista declarada en el router
            EsModal:true,//indica si es modal o no,
            CloseModal:true,//indica si el modal cierra o de lo contrario asignarle un evento al boton
            size :"modal-xl",
            NameList:"Propuestas",
            NameForm:"Lista de Cotizaciones de Servicios",
            urlApi:"propuestas/get",
            ListPropuesta:[],
            ListaHeader:[],
            Rutaicono:'',
            Filtro:{
                Nombre:'',
                Placeholder:'Número, Nombre, Propiedad...',
				TotalItem:0,
                Pagina:1,
                Entrada:20,
				IdVendedor:'',
				Estatus:'',
				Tipo:''
            },
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			ListaVendedores:[],
			ConfigModalPropuesta:{
				NombreSeccion:"Propuesta",
                EmitSeccion:"Propuesta",
                Size:"modal-lg",
                Nombre:"Propuesta",
                NameForm:"Propuesta"
			},
			oBtnSavePropuesta:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Propuesta",
                EmitSeccion:"Propuesta"
            },
			ShowButtonPropuesta:true,
			RolUsuario:'',
			IdUsuario:'',
			BtnNewDisabled:false,
			Vendedor:{}
        }
    },
    methods: {
		async Lista() {
			if (this.BtnNewDisabled===false) {
				this.ConfigLoad.ShowLoader = true;

				await this.$http.get(
					this.urlApi,
					{
						params:{
							Nombre:this.Filtro.Nombre,
							Entrada:this.Filtro.Entrada,
							pag:this.Filtro.Pagina, 
							RegEstatus:'A',
							Origen:'modulo',
							IdSucursal:JSON.parse(sessionStorage.getItem('user')).IdSucursal,
							IdVendedor:this.Filtro.IdVendedor,
							Estatus:this.Filtro.Estatus,
							Tipo:this.Filtro.Tipo,
							Creador:this.RolUsuario!='admin' ? this.IdUsuario : ''
						}
					}
				).then( (res) => {
					this.ListPropuesta =res.data.data.propuestas;
					this.Filtro.Entrada=res.data.data.pagination.PageSize;
					this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader = false;
				});	
			}
			else{
				this.ConfigLoad.ShowLoader = false;
			}
		},

        Eliminar(Id)
        {
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    this.$http.delete(
                        'propuestas/' + Id
                    ).then( (res) => {
                        this.$toast.success('Información eliminada');
                        this.Lista();
                    });
                }
            });
        },
		GetVendedores(){
			this.$http.get('vendedorcotizacion/get').then((res)=>{
				this.ListaVendedores=res.data.data.vendedor;
				// console.log(this.RolUsuario);
				if (this.RolUsuario!='admin') {
					let IndexVendedor=this.ListaVendedores.findIndex((value) => value.IdUsuario==this.IdUsuario);
					if (IndexVendedor!=-1) {
						this.Filtro.IdVendedor=this.ListaVendedores[IndexVendedor].IdVendedor;
						this.Vendedor=this.ListaVendedores[IndexVendedor];
					}
					else{
						this.Vendedor={IdVendedor:'',IdUsuario:'',Nombre:'',IdSucursal:'',Telefono:'',Correo:''}
						this.BtnNewDisabled=true;
					}
				}
				else{
					this.Vendedor={IdVendedor:'0',IdUsuario:'',Nombre:'',IdSucursal:'',Telefono:'',Correo:''}
				}
				// console.log(this.Vendedor);
				this.Lista();
			})
		},
        Change(titulo)
        {
            this.NameForm=titulo;
            var bdn=true;
            if(titulo=='Iconos'){
                bdn=false;
            }
            this.bus.$emit('cambiar_CloseModal',bdn);
        },
        Limpiar(){
            this.bus.$emit('cambiar_CloseModal',true);
        },
        get_form(){
            this.$router.push({name:'cotizacion_principal', params: { tipolistp:this.TipoList,Id:0}});
        },
        Descargar(IdCotizacion)
        {
            this.$http.get('reporte/Cotizacion',
            {
                responseType: 'blob',
                params :{
                        key:IdCotizacion,
                    }
            }).then( (response) => {
                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
                /*
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Servicio.pdf');
                document.body.appendChild(fileLink);
                fileLink.click();*/
            });
        },
		DescargarCliente(IdCotizacion,FechaCotiServicio){
			let ActivarSpinner = document.getElementById(`propuesta${IdCotizacion}`);
            ActivarSpinner.setAttribute('class','fa fa-spinner fa-pulse fa-1x fa-fw');
			let FechaCotizacion=new Date(FechaCotiServicio).getTime();
			// console.log(FechaCotiServicio);
			let FechaComparar=new Date('2025-11-18').getTime();
			// console.log(FechaComparar);
			let Ruta='';
			if (FechaCotizacion<FechaComparar) {
				Ruta='reporte/cotizacioncliente';
			}
			else{
				Ruta='reporte/cotizacionclientepro';
			}
			this.$http.get(Ruta,
            {
                responseType: 'blob',
                params :{
                        key:IdCotizacion,
                    }
            }).then( (response) => {
                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
				ActivarSpinner.setAttribute('class','fas fa-file-pdf');
            });
		},

		DescargarDistribuidor(IdCotizacion){
			this.$http.get('reporte/cotizaciondistribuidor',
            {
                responseType: 'blob',
                params :{
                        key:IdCotizacion,
                    }
            }).then( (response) => {
                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
            });
		},
		AbrirDocumento(Nombre){
            let archivo = Nombre;
			window.open(
				archivo,
				"_blank",
				"toolbar=1, scrollbars=1, resizable=1, width=" +
					1015 +
					", height=" +
					800
			);
        },
		NombreTipoPropuesta(Cadena){
			let Valor='';
			switch (Cadena) {
				case '1':
					Valor='Mantenimiento';
					break;
				case '2':
					Valor='Servicio';
					break;
				case '3':
					Valor='Proyecto';
					break;
				default:
					break;
			}
			return Valor;
		},
    },
    created()
    {
		let usuario=JSON.parse(this.RolUsuario=sessionStorage.getItem("user"));
		this.RolUsuario=usuario.Perfil.toLowerCase();
		this.IdUsuario=usuario.IdUsuario;

        this.bus.$off('Delete');
        this.bus.$off('List');
        this.bus.$off('Limpiar');
        this.bus.$off('Regresar');
        // this.bus.$off('Nuevo');
		this.GetVendedores();
        // this.Lista();

        // this.bus.$on('Nuevo',()=>
        // {
        //     this.get_form();
        // });

        this.bus.$on('Delete',(Id)=>
        {
            this.Eliminar(Id);

        });
        this.bus.$on('List',()=>
        {
            this.Lista();
        });

        this.bus.$on('Limpiar',()=>
        {
            this.Limpiar();
        });
        this.bus.$on('Regresar',()=>
        {
            this.$router.push({name:'submenucotizacion'});
        });
		this.bus.$off('EnableBtnPropuesta');
		this.bus.$on('EnableBtnPropuesta',(Id,IdCotizacionServicio)=>{
			// console.log(this.ShowButtonPropuesta);
			if (Id==0) {
				this.ShowButtonPropuesta=true;
			}
			else{
				if (IdCotizacionServicio>0) {
					this.ShowButtonPropuesta=false;
				}
				else{
					this.ShowButtonPropuesta=true;
				}
			}
		})
    }
}
</script>
